import React from 'react';
import { css } from '@emotion/react';
import { useSelector } from 'react-redux';
import { color } from '@/styles';
import { showMedicalContentSelector } from '@/redux/config/selfData';

interface Props {
  name: string;
  unitName: string;
  roomName: string | null;
  memo?: string;
  middleElement?: React.ReactNode;
  rightElement: React.ReactNode;
}

const ResidentHeaderWrapper = css`
  width: 100%;
  min-height: 48px;
  padding: 8px 16px;
  background-color: ${color.white};
  border-radius: 8px 8px 0 0;
  position: relative;
  z-index: 1;
`;

const Container = css`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px 0;
`;

const Name = css`
  display: flex;
  gap: 8px;
  font-weight: bold;
  font-size: 18px;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const LeftContainer = css`
  display: flex;
  justify-content: center;
  flex-direction: column;
  min-width: 0;
  min-height: 48px;
  margin-right: 24px;
`;

const RightContainer = css`
  display: flex;
  justify-content: end;
  flex-grow: 1;
`;

const MemoRow = css`
  font-size: 14px;
  overflow-wrap: break-word;
`;

const ResidentInfo = css`
  font-size: 14px;
  word-break: break-word;
  overflow-wrap: break-word;
`;

const MedicalResidentInfo = css`
  font-size: 12px;
  color: ${color.dark_gray};
`

export const ResidentItemHeader = React.memo(
  ({ name, unitName, memo, roomName, middleElement, rightElement }: Props) => {
    const showMedicalContent = useSelector(showMedicalContentSelector);

    return (
      <div css={ResidentHeaderWrapper}>
        <div css={Container}>
          <div css={LeftContainer}>
            <div css={Name}>{name}</div>
            <div css={[ResidentInfo, showMedicalContent && MedicalResidentInfo]}>
              {unitName}
              {!showMedicalContent && roomName && unitName ? ' - ' : ' '}
              {roomName}
            </div>
            {memo && <div css={MemoRow}>{memo}</div>}
          </div>
          {middleElement && <div>{middleElement}</div>}
          <div css={RightContainer}>{rightElement}</div>
        </div>
      </div>
    );
  }
);
